import { DrawerCloseButtonProps } from './@types/DrawerCloseButtonProps';
import DrawerCloseButtonContainer from './handles/DrawerCloseButtonContainer';
import DrawerCloseButtonProvider from './hooks/useDrawerCloseButton';

const DrawerCloseButton = (props: DrawerCloseButtonProps) => (
	<DrawerCloseButtonProvider {...props}>
		<DrawerCloseButtonContainer />
	</DrawerCloseButtonProvider>
);

export default DrawerCloseButton;
